import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { dataLayerPush } from '@r1-frontend/analytics/dataLayerPush';

import { btnSizes, btnTypes } from '@r1-frontend/ui-react/components/buttons/baseButton';
import { CATEGORIES, EVENTS } from '@r1-frontend/shared/constants/analytics';
import { USER_LOGIN_ROUTE } from '@r1-frontend/shared/constants/routes';

import { IUnauthHeaderProps } from '~/src/features/_layout/Header/types';
import { useLeadGeneration } from '~/src/features/_layout/Header/UnauthHeader/useLeadGeneration';
import { useIsMsk } from '~/src/helpers/hooks/useIsMsk';
import { selectCompanyName } from '~/src/store/selectors/city';

import * as ST from './styled';

export interface IConnectionAndLoginBurgerViewProps {
    onOpenBecomeClientPopup: IUnauthHeaderProps['onBecomeClientHandler'],
    referrerPath: string,
    closeHandler?: () => void,
}

const BurgerView = ({
    onOpenBecomeClientPopup,
    referrerPath,
    closeHandler,
}: IConnectionAndLoginBurgerViewProps): JSX.Element => {
    const companyName = useSelector(selectCompanyName);
    const { showButton } = useLeadGeneration();
    const isMsk = useIsMsk();

    const openConnectionPopup = () => {
        onOpenBecomeClientPopup(isMsk ? 'callback' : 'connect');
    };

    const sendAuthEvent = useCallback((action = 'Войти в личный кабинет') => {
        closeHandler && closeHandler();
        dataLayerPush({
            event: EVENTS.UAevent,
            category: CATEGORIES.mainMenuClick,
            action,
            label: 'menu_new',
        });
    }, [closeHandler]);

    return (
        <ST.ButtonsBlock>
            {showButton && (
                <ST.Button
                    type={btnTypes.ACCENT}
                    size={btnSizes.SMALL}
                    text={'Подключить ' + companyName}
                    onClick={openConnectionPopup}
                    isBurgerOpen={true}
                />
            )}
            <ST.Button
                type={btnTypes.SECONDARY}
                size={btnSizes.SMALL}
                href={USER_LOGIN_ROUTE + referrerPath}
                onClick={() => sendAuthEvent('Войти в личный кабинет')}
                isBurgerOpen={true}
            >
                <ST.Login data-test='lk-login-abn'>Войти</ST.Login>
            </ST.Button>
        </ST.ButtonsBlock>
    );
};

export default BurgerView;
